// extracted by mini-css-extract-plugin
export default {"properties":"pJtiI","propertiesRow":"_K6wJ"};